export const getContentDispositionFileName = (
  contentDisposition: string
): string | null => {
  // First try to match RFC 5987 encoded filename (filename*=UTF-8''...)
  const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (rfc5987Match && rfc5987Match[1]) {
    return decodeURIComponent(rfc5987Match[1]);
  }

  // Fall back to standard filename parameter
  const fileNameMatch = contentDisposition.match(
    /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  );

  return fileNameMatch && fileNameMatch[1]
    ? // Remove quotes if present and use the filename from the header
      fileNameMatch[1].replace(/['"]/g, '')
    : null;
};

export const getContentDispositionFileExtension = (
  contentDisposition: string
): string | null => {
  const fileName = getContentDispositionFileName(contentDisposition);

  if (!fileName || !fileName.includes('.')) {
    return null;
  }

  return fileName.split('.').pop() ?? null;
};
